var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:(_vm.calculatePositionStyle)}),(_vm.isLeftAd)?_c('AdPanel',{attrs:{"content":_vm.isLeftAdContent,"adPosition":"left","marginLeft":_vm.marginLeft}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }